















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import DiscountChangeDialog from '@/modules/shared/components/admin/discount-change/DiscountChangeDialog.vue'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'

@Component({
  components: { DiscountChangeDialog }
})
export default class DiscountValue extends Vue {
  @Prop({ required: true, default: null }) useCase!: BaseRequestLoadingHandler
  @Prop({ required: true }) id!: number[] | number
  @Prop({ default: 0 }) amount !: number | null
  @Prop({ default: true }) editable !: boolean

  get getAmount() {
    return Number(this.amount).toLocaleString()
  }
}
